import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../helpers/axios";
import { Box, IconButton, Typography } from "@mui/material";
import "./VerificationTab.css";
import applicant from "../../assets/images/applicant.png";
import eye from "../../assets/images/eye.png";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CustomAutoComplete from "../AutoComplete/AutoComplete";
import CloudDoneIcon from '@mui/icons-material/CloudDone';
const user = null;
const VerificationTab = (props) => {
  const { user } = props;
  const { appId } = useSelector((state) => state.appContext);
  const [details, setDetails] = useState(null);
  const [url, setUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [responseData, setRepsonseData] = useState([]);
  const [totalVerifications, setTotalVerifications] = useState([]);
  const [selectedType, setSelectedType] = useState()
  
  useEffect(() => {
    getVerificationDetails();
  }, []);

  const getParsedData = (data) => {
    const fileEntries = JSON.parse(data?.fileEntries);
    const refNumbers = JSON.parse(data?.refNumbers);
    return { ...data, fileEntries, refNumbers };
  };

  const getVerificationDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `/verification-tab/details?applicationId=${appId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = res?.data;
      if (data?.message === "Successful") {
        setRepsonseData(data?.data);
        const options = data?.data?.map((item, index) => ({
          label: `Verification ${index + 1}`,
        }));
        setTotalVerifications(options);

      }
    } catch (e) {
    }
  };

  const handleClick = async (s3Url) => {
    const filePath = s3Url.split(".com/")[1];
    const url = `/file/url-content?path=${filePath}`;
    try {
      const res = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = res?.data;
      if (data?.message === "Successful") {
        setOpen(true);
        setUrl(data?.data);
      }
    } catch (e) {
    }
  };

  const handleVerificationType = (vType) => {
    const index = vType?.split(" ")[1];
    if(index){
      setSelectedType(index)
      const showDetails = getParsedData(responseData[index - 1]);
      setDetails(showDetails);
    }
    
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "space-between",
        paddingBottom: "12px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <CustomAutoComplete
          label="Select Verification"
          styles={{ width: "180px" }}
          options={totalVerifications}
          handleAutoCompleteChange={(vType) => handleVerificationType(vType)}
        />
      </Box>
      {/* Verification Details */}
      <Box
        style={{
          borderRadius: "10px",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "49%",
          border: "1px solid rgb(219, 219, 219)",
        }}
      >
        <div
          style={{
            paddingLeft: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <img
              style={{ height: "33px", width: "33px" }}
              src={applicant}
              alt="applicant"
            />
            <p
              style={{
                marginLeft: "20px",
                fontFamily: "Inter-Medium",
                color: "#232323",
                marginTop: "13px",
                fontWeight: "500",
              }}
            >
              Verification {selectedType} Details
            </p>
          </div>
        </div>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "20px",
            borderTop: "1px solid rgb(219, 219, 219)",
          }}
        >
          <Box className="item">
            <span className="spanEle">House </span>
            <span className="value">{details?.houseType || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">House Address </span>
            <span className="value">{details?.houseAddress || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">PAN </span>
            <span className="value">{details?.panStatus || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">Aadhar </span>
            <span className="value">{details?.aadhaarStatus || '--'}</span>
          </Box>

          <Box className="item">
            <span className="spanEle">Email </span>
            <span className="value">{details?.email || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">Employment Type </span>
            <span className="value">{details?.employment || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">EmployerName </span>
            <span className="value">{details?.employerName || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">Salary </span>
            <span className="value">{details?.salary || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">Person Met </span>
            <span className="value">{details?.personName || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">Done By </span>
            <span className="value">{details?.doneBy || '--'}</span>
          </Box>
          {details?.refNumbers?.length > 0 && (
            <Box
              style={{
                displpay: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <Typography fontWeight="600" fontSize="14px">
                Reference Contacts
              </Typography>
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {details.refNumbers.map((ref, index) => {
                  const name =
                    ref[`name${index + 1}`] ||
                    ref.name ||
                    `Reference ${index + 1}`;
                  const contact =
                    ref[`contact${index + 1}`] || ref.contact || "N/A";
                  const relationship =
                    ref[`relationship${index + 1}`]?.label ||
                    ref.relationship?.label ||
                    "N/A";

                  return (
                    <Box
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "#f9f9f9",
                        padding: "5px",
                        marginBottom: "5px",
                        width: "48%",
                      }}
                    >
                      <Typography fontSize={13}>
                        <span>Name:</span> {name}
                      </Typography>
                      <Typography fontSize={13}>
                        <span>Contact:</span> {contact}
                      </Typography>
                      <Typography fontSize={13}>
                        <span>Relationship:</span> {relationship}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
          <Box className="item">
            <span className="spanEle">Comments </span>
            <span className="value">{details?.comments || '--'}</span>
          </Box>
          <Box className="item">
            <span className="spanEle">File Satisfaction </span>
            <span className="value">{details?.fileSatisfaction || '--'}</span>
          </Box>
        </Box>
      </Box>

      {/* File Upload Details */}
      <Box
        style={{
          borderRadius: "10px",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "48%",
          border: "1px solid rgb(219, 219, 219)",
          height: "fit-content",
        }}
      >
        <div
          style={{
            paddingLeft: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <CloudDoneIcon sx={{ color: "#232323",}}/>
            <p
              style={{
                marginLeft: "20px",
                fontFamily: "Inter-Medium",
                color: "#232323",
                marginTop: "13px",
                fontWeight: "500",
              }}
            >
              Files Uploaded
            </p>
          </div>
        </div>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px",
            borderTop: "1px solid rgb(219, 219, 219)",
          }}
        >
          {details?.fileEntries?.map(
            (file, index) =>
              file && (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    bgcolor: "#f5f5f5",
                    mb: 1,
                    borderRadius: 1,
                  }}
                >
                  <Typography fontSize={12}>{file?.name}</Typography>
                  <IconButton
                    size="small"
                    onClick={() => handleClick(file?.s3Url)}
                  >
                    <img src={eye} alt="view" />
                  </IconButton>
                </Box>
              )
          )}
        </Box>
      </Box>
      <Modal isOpen={open} size="xl" style={{ height: "80%", marginTop: 15 }}>
        <ModalHeader toggle={() => setOpen(false)}></ModalHeader>
        <ModalBody style={{ height: "100%" }}>
          <iframe
            src={url}
            width="100%"
            height="600vh"
            style={{ border: "none" }}
          ></iframe>
        </ModalBody>
      </Modal>
    </Box>
  );
};

export default VerificationTab;
